import React, { useRef, useState } from 'react';
import resizeImg from '../../assets/resize.png';
import resizeDarkImg from '../../assets/resize-dark.png';
import { useDispatch, useSelector } from 'react-redux';
import { generateGridTemplateColumns } from '../../helpers';
import { updateTitleSize } from '../../redux/orderSlice';
import sortImg from '../../assets/sort/sort.png';
import sortDarkImg from '../../assets/sort/sort-dark.png';

const OrderTitle = ({
    colName,
    label,
    size,
    isResizing,
    selectedTitle,
    clickTitle,
    isLightTheme,
    sort,
    
}) => {
    const TITLE_MIN_WIDTH = 50;
    const currentWidth = parseInt(size) || TITLE_MIN_WIDTH;
    const dispatch = useDispatch();
    const titleRef = useRef();
    const isSelected = selectedTitle === colName;

    const wheelHandler = (event) => {
        if (!isSelected || !isResizing) return;
        if (event.ctrlKey) {
            const deltaX = event.deltaY > 0 ? 10 : -5;
            let newWidth = currentWidth + deltaX;
            newWidth = newWidth < TITLE_MIN_WIDTH ? TITLE_MIN_WIDTH + 'px' : newWidth + 'px';
            dispatch(updateTitleSize({ [colName]: newWidth }));
        }
    };

    const isSortByThis = sort.key === colName;
    const isASC = sort.isASC;

    return (
        <div
            ref={titleRef}
            onClick={() => clickTitle(colName)}
            onWheel={wheelHandler}
            data-colname={colName}
            className={`cell title-cell ${isSelected ? 'selected' : ''} ${isSortByThis ? 'sort-this' : ''}`}>
            {label}
            {isSortByThis && <img src={isLightTheme ? sortImg : sortDarkImg} className={`${!isASC ? 'down' : ''}`} alt="" />}
        </div>
    );
};

export const OrderTitles = ({ titles, isResize, setResize, isLightTheme, sort, setSort }) => {
    const titleSizes = useSelector((state) => state.orders.orderTitles);
    const gridTemplateColumns = generateGridTemplateColumns(titleSizes, titles);
    const [selectedTitle, selectTitle] = useState(titles[0].key);

    const selectTitleHandler = (key) => {  //2 funcs
        if (isResize) {
            selectTitle(key);
        } else {
            if (key === sort.key) {
                setSort({key, isASC: !sort.isASC})
            } else {
                setSort({key, isASC: sort.isASC})
            }
        }
    }

    return (
        <div className="order-titles-container">
            <img
                src={isLightTheme ? resizeImg : resizeDarkImg}
                className={`${isResize ? 'selected' : ''}`}
                alt=""
                onClick={() => setResize((prev) => !prev)}
            />
            <div
                className={`order-titles ${isResize ? 'resizable' : ''}`}
                style={{ gridTemplateColumns }}>
                {
                    titles.map((t) => (
                        <OrderTitle
                            sort={sort}
                            setSort={setSort}
                            isResizing={isResize}
                            clickTitle={selectTitleHandler}
                            selectedTitle={selectedTitle}//@ts-ignore
                            size={titleSizes[t.key]}
                            key={t.key}
                            colName={t.key}
                            label={t.label}
                            isLightTheme={isLightTheme}
                        />
                    ))
                }
            </div>
        </div>
    );
};
